<template>
  <SectionContentBadgeImageTextSplit v-bind="props" />
</template>

<script setup>
const props = defineProps({
  badgeText: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: 'Sleep'
  },
  content: {
    type: String,
    default: `<p>Of course, contrary to what many of us think (in action) we can't run on coffee alone.</p>
<p>It's easy to sacrifice sleep for any number of things in life, both work and play, but sleep is crucial for optimal energy levels.</p>
<p>Yes, all the coffee in the world won't improve your energy levels if you're not getting adequate restful sleep.</p>
<ul>
  <li>When you sleep, your energy stores are replenished.</li>
  <li>When you sleep, your body repairs itself at the cellular level.</li>
  <li>During sleep, your body also regulates insulin levels, a necessity for daytime energy and your body's overall need and usage of energy.</li>
  <li>Brain function also improves with sleep, so you can reap the reward of mental focus and alertness throughout the day.</li>
</ul>
<p>Most experts recommend 7-9 hours of quality sleep each night for men.</p>
<p>And, getting regular exercise, eating a healthy diet, limiting afternoon caffeine, establishing a nighttime routine, avoiding late night meals, and avoiding screens within 2 hours of bed can all help you achieve the restful sleep your body needs.<sup>29</sup></p>`
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: 'Man sleeping peacefully in bed'
  },
  imagePosition: {
    type: String,
    default: 'right'
  },
  contentGap: {
    type: String,
    default: 'medium'
  },
  showDivider: {
    type: Boolean,
    default: false
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  },
  paddingBottom: {
    type: String,
    default: 'reduced'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Split Sleep',
  inputs: [
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Sleep'
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue: `<p>Of course, contrary to what many of us think (in action) we can't run on coffee alone.</p>
<p>It's easy to sacrifice sleep for any number of things in life, both work and play, but sleep is crucial for optimal energy levels.</p>
<p>Yes, all the coffee in the world won't improve your energy levels if you're not getting adequate restful sleep.</p>
<ul>
  <li>When you sleep, your energy stores are replenished.</li>
  <li>When you sleep, your body repairs itself at the cellular level.</li>
  <li>During sleep, your body also regulates insulin levels, a necessity for daytime energy and your body's overall need and usage of energy.</li>
  <li>Brain function also improves with sleep, so you can reap the reward of mental focus and alertness throughout the day.</li>
</ul>
<p>Most experts recommend 7-9 hours of quality sleep each night for men.</p>
<p>And, getting regular exercise, eating a healthy diet, limiting afternoon caffeine, establishing a nighttime routine, avoiding late night meals, and avoiding screens within 2 hours of bed can all help you achieve the restful sleep your body needs.<sup>29</sup></p>`
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: 'Man sleeping peacefully in bed'
    },
    {
      name: 'imagePosition',
      type: 'text',
      enum: ['left', 'right'],
      defaultValue: 'right'
    },
    {
      name: 'contentGap',
      type: 'text',
      enum: ['large', 'medium'],
      defaultValue: 'medium'
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    }
  ]
})
</script>
